import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hydrateFromStorage } from '../store/slices/authSlice';

/** Sync Redux auth state from localStorage on app load. */
const AuthBootstrap = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(hydrateFromStorage());
  }, [dispatch]);
  return null;
};

export default AuthBootstrap;
